export default {
	get: (key) => {
		return localStorage.getItem(key);
	},
	set: (key, value) => {
		localStorage.setItem(key, value);
	},
	getToken: () => {
		return localStorage.getItem('token');
	},
	setToken: (token) => {
		localStorage.setItem('token', token);
	}
}



// WEBPACK FOOTER //
// /src/components/extra/LocalStorage.js